import { LAST_SELECT_TIMEZONE_ID, apiHolder, apis } from 'api';
import { EnhanceSelect, InSingleOption } from '@web-common/components/UI';
import React, { useCallback, useMemo } from 'react';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { ScheduleActions, useActions, useAppSelector } from '@web-common/state/createStore';
import styles from './scheduleTimeZoneSelect.module.scss';
import { getDurationText } from '@web-common/components/util/ics';
const catalogApi = apiHolder.api.requireLogicalApi(apis.catalogApiImpl);
const storeApi = apiHolder.api.getDataStoreApi();
const tag = 'scheduleTimeZoneSelect';
const ScheduleTimezoneSelect = ({ bordered = false, showTimeDiffLabel = false, localZoneStartTime = new Date(), localZoneEndTime = new Date(), allDay = false, durationTextLabelStyle = {}, labelBreakLine = false, renderLabelAsGMTFormat = false, selectClassName = '', }) => {
    const { settingZoneList: sZoneList = [], showSecondaryZone: sShowSecondaryZone, lastSelectTimezone } = useAppSelector(state => state.scheduleReducer);
    const [zoneList, setZoneList] = useState([]);
    const [lastSelectTimezoneId, setLastSelectTimezoneId] = useState(290);
    const scheduleActions = useActions(ScheduleActions);
    useEffect(() => {
        catalogApi.getZoneList().then(_zoneList => {
            const res = storeApi.getSync(LAST_SELECT_TIMEZONE_ID);
            let _lastSelectTimezoneId;
            if ((res === null || res === void 0 ? void 0 : res.suc) && (res === null || res === void 0 ? void 0 : res.data)) {
                _lastSelectTimezoneId = Number(res.data);
            }
            else {
                _lastSelectTimezoneId = _zoneList[0].id;
            }
            setLastSelectTimezoneId(_lastSelectTimezoneId);
            setZoneList(_zoneList);
            scheduleActions.setLastSelectTimezone(_zoneList.find(item => item.id === _lastSelectTimezoneId) || zoneList[0]);
        });
    }, []);
    const secondaryZoneList = useMemo(() => {
        if (zoneList.length === 0 || sZoneList.length === 0)
            return [];
        const zoneListMap = new Map();
        zoneList.forEach(item => {
            zoneListMap.set(item.id, item);
        });
        return sZoneList.map(id => zoneListMap.get(id));
    }, [sZoneList, zoneList]);
    const handleZoneItemChange = useCallback(value => {
        console.log(tag, 'handleZoneItemChange id', value);
        setLastSelectTimezoneId(value);
        if (zoneList.length > 0) {
            scheduleActions.setLastSelectTimezone(zoneList.find(item => item.id === value) || zoneList[0]);
        }
        storeApi.putSync(LAST_SELECT_TIMEZONE_ID, value);
    }, [zoneList]);
    useEffect(() => {
        try {
            if (zoneList.length > 0) {
                let lastTimezoneIdExists = sZoneList.find(id => id === lastSelectTimezoneId);
                let backTimezone = zoneList.find(item => item.id === sZoneList[0]);
                if (!lastTimezoneIdExists) {
                    const defualtId = backTimezone || zoneList[0];
                    console.log(tag, 'setLastSelectTimezone', defualtId);
                    handleZoneItemChange(defualtId.id);
                }
            }
        }
        catch (error) {
            console.error('setLastSelectTimezone error', error);
        }
    }, [sZoneList, zoneList]);
    useEffect(() => {
        if (!(lastSelectTimezone === null || lastSelectTimezone === void 0 ? void 0 : lastSelectTimezone.id) || (lastSelectTimezone === null || lastSelectTimezone === void 0 ? void 0 : lastSelectTimezone.id) === lastSelectTimezoneId) {
            return;
        }
        handleZoneItemChange(lastSelectTimezone === null || lastSelectTimezone === void 0 ? void 0 : lastSelectTimezone.id);
    }, [lastSelectTimezone]);
    const renderDurationTextByTimeZone = (optionItem) => {
        if (renderLabelAsGMTFormat) {
            const localTimezone = -(new Date().getTimezoneOffset() / 60);
            const minutes = `${Math.floor((localTimezone % 1) * 60)}`.padStart(2, '0');
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: styles.durationText, style: Object.assign({ color: 'var(---Text-4-, #545A6E)' }, durationTextLabelStyle) }, `GMT${localTimezone >= 0 ? '+' : '-'}${`${Math.floor(localTimezone)}`.padStart(2, '0')}:${minutes}`),
                React.createElement("span", { className: styles.durationTextExt, style: Object.assign({}, durationTextLabelStyle) }, optionItem.offset)));
        }
        const { startStr, endStr, affixStr, crossDay, crossYear } = getDurationText(localZoneStartTime, localZoneEndTime, !!allDay, true, false, optionItem === null || optionItem === void 0 ? void 0 : optionItem.totalSeconds);
        const breakLine = labelBreakLine && crossDay;
        return (React.createElement("div", { className: styles.durationWrap },
            React.createElement("span", { className: styles.durationText, style: Object.assign(Object.assign({ display: 'inline-block' }, durationTextLabelStyle), { width: breakLine && !allDay ? 300 : 'auto' }) },
                `${startStr}${breakLine ? '' : endStr}`,
                !breakLine ? ` (${optionItem.offset})` : ''),
            breakLine && React.createElement("span", { className: styles.durationTextExt, style: Object.assign({}, durationTextLabelStyle) }, `${endStr}(${optionItem.offset})`)));
    };
    const rederOption = (item) => {
        return (React.createElement(InSingleOption, { value: item.id, label: showTimeDiffLabel ? renderDurationTextByTimeZone(item) : item.content, key: item.id }, `${item.content} ${item.key}`));
    };
    return sShowSecondaryZone && (sZoneList === null || sZoneList === void 0 ? void 0 : sZoneList.length) ? (React.createElement(EnhanceSelect, { value: lastSelectTimezoneId, bordered: bordered, style: { height: labelBreakLine ? 40 : 30 }, onChange: value => {
            handleZoneItemChange(value);
        }, dropdownAlign: { overflow: { adjustX: true, adjustY: true } }, optionLabelProp: "label", className: classnames([styles.timeZoneSelectWrap], [selectClassName]), dropdownMatchSelectWidth: false, dropdownClassName: "extheme" }, secondaryZoneList.map(zoneItem => {
        return rederOption(zoneItem);
    }))) : (React.createElement(React.Fragment, null));
};
export default ScheduleTimezoneSelect;
